<template lang="pug" src="./trip.pug"></template>

<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'

export default {
  name: 'Trip',
  data: function () {
    return {
      rating: 3,
      items: [{}]
    }
  },
  methods: {
    ...mapGetters(['isTokenSet']),
    ...mapActions(['getTripInfo']),

    async getTrip(){
      await this.getTripInfo({
        identity: window.localStorage.getItem('selectedHotspot').split('"').join('')
      })
      this.items = this.tripInfo
    }
  },
  computed: {

      selectedHs () {
        return this.$store.state.adminHotspots.selectedHotspot
      },

      tripInfo(){
        return this.$store.state.adminSocial.tripData
      }
  },

   created () {
     this.getTrip()
   },

   watch: {
     selectedHs () {
       this.getTrip()
     }
   }
}
</script>
